import React from 'react';
// import { Link } from 'react-router';
import './TwitchDropCard.scss';

// const maxChar = 72;
// const truncate = str => `${str.slice(0, maxChar) + (str.length > maxChar ? '...' : '')}`;

function TwitchDropCard({
  data: {
    coverBannel = '', coverPortrait = '', developer, developerLogo, id, name, headline = '', platforms = []
  },
}) {
  // const headlineText = htmlToPlainText(headline);
  // const truncated = headlineText.length > maxChar;
  // const images = getPlatformImages(platforms);
  return (
    <div className="twitch-drop-card">
      <div className="image-container">
        <div
          className="image"
          style={{ backgroundImage: `url(${coverBannel ? coverBannel : coverPortrait})` }}
        >
          <div className="image-overlay" />
        </div>
      </div>
    </div>
  );
}

export default TwitchDropCard;
